import { PicCenterOutlined } from '@ant-design/icons';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { DividerWidgetComponent } from './DividerWidgetComponent.tsx';
import {
  DividerWidgetConfigComponent,
  DividerWidgetConfigSchema,
} from './DividerWidgetConfigComponent.tsx';
import { type IDividerWidget } from './IDividerWidget.ts';
import { renderDividerHtml } from './renderDividerHtml.ts';

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const DividerWidgetType: IWidgetType<IDividerWidget> = {
  type: WidgetType.Divider,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Titolo Divisore',
  icon: <PicCenterOutlined />,
  hasValue: false,
  formComponent: DividerWidgetComponent,
  configComponent: DividerWidgetConfigComponent,
  configValidator: DividerWidgetConfigSchema,
  previewComponent: DividerWidgetComponent,
  translationSchema: tran.widget({
    title: tran.rte(),
  }),
  rules: [],
  renderHtml: renderDividerHtml,
};
